<cx-view class="card">
  @if (isLoading$ | async) {
    <div>
      <div class="header">
        <div class="title-bar">
          <div class="title">
            <h3>
              {{ i18nRoot + '.title' | cxTranslate }}
            </h3>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="cx-spinner">
          <cx-spinner> </cx-spinner>
        </div>
      </div>
    </div>
  } @else {
    @if (form$ | async; as form) {
      <form [formGroup]="form" (submit)="save(form)">
        <div class="header">
          <div class="title-bar">
            <div class="title">
              <h3>
                {{ i18nRoot + '.title' | cxTranslate }}
              </h3>
            </div>
            <div class="actions">
              <button class="btn btn-secondary"
                type="submit">
                {{ 'branchDetails' + '.buttons.save' | cxTranslate }}
              </button>
              <a class="link close" routerLink="../">
                <cx-icon
                  type="CLOSE"
                ></cx-icon>
              </a>
            </div>
          </div>
        </div>
        <div class="main">
          <section main class="details branch-form">
            <h5 class="heading">{{ 'branchDetails' + '.masterData' | cxTranslate }}:</h5>
            <div class="row branch-form-row">
              <div class="title col">
                {{ 'branchDetails' + '.branchId' | cxTranslate }}
              </div>
            </div>
            <div class="row branch-form-row">
              <div class="col col-sm-11">
                <input
                  type="text"
                  class="form-control"
                  required
                  placeholder="{{ 'branchDetails' + '.branchId' | cxTranslate }}"
                  formControlName="branchId"
                  [readOnly]="!isCreate"
                  />
                  <cx-form-errors [control]="form.get('branchId')"></cx-form-errors>
                </div>
              </div>
              <div class="row branch-form-row">
                <div class="title col">
                  {{ 'branchDetails' + '.name' | cxTranslate }}
                </div>
              </div>
              <div class="row branch-form-row">
                <div class="col col-sm-11">
                  <input
                    type="text"
                    class="form-control"
                    required
                    placeholder="{{ 'branchDetails' + '.namePlaceHolder' | cxTranslate }}"
                    formControlName="name"
                    [readOnly]="!isCreate"
                    />
                    <cx-form-errors [control]="form.get('name')"></cx-form-errors>
                  </div>
                </div>
                <div class="row branch-form-row">
                  <div class="title col col-md-6">
                    {{ 'branchDetails' + '.headOffice' | cxTranslate }}
                  </div>
                  <div class="col col-md-6">
                    <label class="form-check">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        placeholder="headOffice"
                        formControlName="headOffice"
                        />
                      </label>
                    </div>
                  </div>
                  <div class="row branch-form-row">
                    <div class="title col">
                      {{ 'branchDetails' + '.ownerOrManager' | cxTranslate }}
                    </div>
                  </div>
                  <div class="row branch-form-row">
                    <div class="col col-sm-11">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="{{ 'branchDetails' + '.ownerOrManagerPlaceHolder' | cxTranslate }}"
                        formControlName="ownerOrManager"
                        />
                      </div>
                    </div>
                    <div class="row branch-form-row">
                      <div class="title col">
                        {{ 'branchDetails' + '.contactPerson' | cxTranslate }}
                      </div>
                    </div>
                    <div class="row branch-form-row">
                      <div class="col col-sm-11">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="{{ 'branchDetails' + '.contactPersonPlaceHolder' | cxTranslate }}"
                          formControlName="contactPerson"
                          />
                        </div>
                      </div>
                      <div class="row branch-form-row">
                        <div class="title col">
                          {{ 'branchDetails' + '.branchVat' | cxTranslate }}
                        </div>
                      </div>
                      <div class="row branch-form-row">
                        <div class="col col-sm-11">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="{{ 'branchDetails' + '.branchVat' | cxTranslate }}"
                            formControlName="branchVat"
                            />
                            <cx-form-errors [control]="form.get('branchVat')"></cx-form-errors>
                          </div>
                        </div>
                        <div class="row branch-form-row">
                          <div class="title col">
                            {{ 'branchDetails' + '.streetAndHouseNo' | cxTranslate }}
                          </div>
                        </div>
                        <div class="row branch-form-row">
                          <div class="col col-sm-11">
                            <input
                              type="text"
                              class="form-control"
                              placeholder="{{ 'branchDetails' + '.streetAndHouseNoPlaceHolder' | cxTranslate }}"
                              formControlName="streetAndHouseNo"
                              />
                            </div>
                            <cx-form-errors [control]="form.get('streetAndHouseNo')"></cx-form-errors>
                          </div>
                          <div class="row branch-form-row">
                            <div class="title col">
                              {{ 'branchDetails' + '.country' | cxTranslate }}
                            </div>
                          </div>
                          <div class="row branch-form-row">
                            <div class="col col-sm-11">
                              <ng-select
                                formControlName="countryCode"
                                [searchable]="false"
                                [clearable]="false"
                                placeholder="{{ 'branchDetails.countryCodes.' + selectedCountryCode | cxTranslate }}"
                                [(ngModel)]="selectedCountryCode">
                                @for (country of supportedCountryCodes; track country) {
                                  <ng-option [value]="country">{{
                                    'branchDetails.countryCodes.' + country | cxTranslate
                                  }}</ng-option>
                                }
                              </ng-select>
                              <cx-form-errors [control]="form.get('countryCode')"></cx-form-errors>
                            </div>
                          </div>
                          <div class="row branch-form-row">
                            <div class="title col">
                              {{ 'branchDetails' + '.postalCode' | cxTranslate }}
                            </div>
                          </div>
                          <div class="row branch-form-row">
                            <div class="col col-sm-11">
                              <input
                                type="text"
                                class="form-control"
                                placeholder="{{ 'branchDetails' + '.postalCodePlaceHolder' | cxTranslate }}"
                                formControlName="postalCode"
                                />
                                <cx-form-errors [control]="form.get('postalCode')"></cx-form-errors>
                              </div>
                            </div>
                            <div class="row branch-form-row">
                              <div class="title col">
                                {{ 'branchDetails' + '.place' | cxTranslate }}
                              </div>
                            </div>
                            <div class="row branch-form-row">
                              <div class="col col-sm-11">
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="{{ 'branchDetails' + '.placePlaceHolder' | cxTranslate }}"
                                  formControlName="place"
                                  />
                                  <cx-form-errors [control]="form.get('place')"></cx-form-errors>
                                </div>
                              </div>
                              <div class="row branch-form-row">
                                <div class="title col">
                                  {{ 'branchDetails' + '.phone' | cxTranslate }}
                                </div>
                              </div>
                              <div class="row branch-form-row">
                                <div class="col col-sm-11">
                                  <input
                                    type="text"
                                    class="form-control"
                                    placeholder="{{ 'branchDetails' + '.phonePlaceHolder' | cxTranslate }}"
                                    formControlName="phone"
                                    />
                                  </div>
                                </div>
                                <div class="row branch-form-row">
                                  <div class="title col">
                                    {{ 'branchDetails' + '.fax' | cxTranslate }}
                                  </div>
                                </div>
                                <div class="row branch-form-row">
                                  <div class="col col-sm-11">
                                    <input
                                      type="text"
                                      class="form-control"
                                      placeholder="{{ 'branchDetails' + '.faxPlaceHolder' | cxTranslate }}"
                                      formControlName="fax"
                                      />
                                    </div>
                                  </div>
                                  <div class="row branch-form-row">
                                    <div class="title col">
                                      {{ 'branchDetails' + '.email' | cxTranslate }}
                                    </div>
                                  </div>
                                  <div class="row branch-form-row">
                                    <div class="col col-sm-11">
                                      <input
                                        type="text"
                                        class="form-control"
                                        placeholder="{{ 'branchDetails' + '.emailPlaceHolder' | cxTranslate }}"
                                        formControlName="email"
                                        />
                                        <cx-form-errors [control]="form.get('email')"></cx-form-errors>
                                      </div>
                                    </div>
                                    <div class="row branch-form-row">
                                      <div class="title col">
                                        {{ 'branchDetails' + '.website' | cxTranslate }}
                                      </div>
                                    </div>
                                    <div class="row branch-form-row">
                                      <div class="col col-sm-11">
                                        <input
                                          type="text"
                                          class="form-control"
                                          placeholder="{{ 'branchDetails' + '.websitePlaceHolder' | cxTranslate }}"
                                          formControlName="website"
                                          />
                                        </div>
                                      </div>
                                      <div class="row branch-form-row">
                                        <div class="title col col-md-6">
                                          {{ 'branchDetails' + '.onlineShop' | cxTranslate }}
                                        </div>
                                        <div class="col col-md-6">
                                          <label class="form-check">
                                            <input
                                              type="checkbox"
                                              class="form-check-input"
                                              placeholder="onlineShop"
                                              formControlName="onlineShop"
                                              />
                                            </label>
                                          </div>
                                        </div>
                                        <div class="row branch-form-row">
                                          <div class="title col col-md-6">
                                            {{ 'branchDetails' + '.branchSearchExport' | cxTranslate }}
                                          </div>
                                          <div class="col col-md-6">
                                            <label class="form-check">
                                              <input
                                                type="checkbox"
                                                class="form-check-input"
                                                placeholder="branchSearchExport"
                                                formControlName="branchSearchExport"
                                                />
                                              </label>
                                            </div>
                                          </div>
                                          @if ((isB2bUnitVendorReporting$ | async) || (!isCreate && isVendorReportingRelevant)) {
                                            <div class="row branch-form-row">
                                              <div class="title col col-md-6">
                                                {{ 'branchDetails' + '.branchVendorReporting' | cxTranslate }}
                                              </div>
                                              <div class="col col-md-6">
                                                <label class="form-check">
                                                  <input
                                                    type="checkbox"
                                                    class="form-check-input"
                                                    placeholder="branchVendorReporting"
                                                    formControlName="branchVendorReporting"
                                                    />
                                                  </label>
                                                </div>
                                              </div>
                                            }
                                          </section>
                                          <section main class="details time-schedule">
                                            <h5 class="heading">{{ 'branchDetails' + '.openHours' | cxTranslate }}:</h5>
                                            <table class="table">
                                              <thead>
                                                <tr>
                                                  <th class="schedule-title">{{ 'branchDetails' + '.weekday' | cxTranslate }}</th>
                                                  <th class="schedule-title">{{ 'branchDetails' + '.morning' | cxTranslate }}</th>
                                                  <th class="schedule-title">{{ 'branchDetails' + '.afternoon' | cxTranslate }}</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                @for (day of days; track day) {
                                                  <tr>
                                                    <td class="schedule-days">
                                                      {{ 'branchDetails' + '.' + day | cxTranslate }}
                                                    </td>
                                                    <td class="form-time">
                                                      <input
                                                        type="text"
                                                        class="form-control"
                                                        placeholder="{{'branchDetails'+ '.timePlaceHolder' | cxTranslate }}"
                                                        formControlName="{{day+'MorningFrom'}}"
                                                        />
                                                        <cx-form-errors [control]="form.get(day+'MorningFrom')"></cx-form-errors>
                                                        <input
                                                          type="text"
                                                          class="form-control"
                                                          placeholder="{{'branchDetails'+ '.timePlaceHolder' | cxTranslate }}"
                                                          formControlName="{{day+'MorningTo'}}"
                                                          />
                                                          <cx-form-errors [control]="form.get(day+'MorningTo')"></cx-form-errors>
                                                        </td>
                                                        <td class="form-time">
                                                          <input
                                                            type="text"
                                                            class="form-control"
                                                            placeholder="{{'branchDetails'+ '.timePlaceHolder' | cxTranslate }}"
                                                            formControlName="{{day+'AfternoonFrom'}}"
                                                            />
                                                            <cx-form-errors [control]="form.get(day+'AfternoonFrom')"></cx-form-errors>
                                                            <input
                                                              type="text"
                                                              class="form-control"
                                                              placeholder="{{'branchDetails'+ '.timePlaceHolder' | cxTranslate }}"
                                                              formControlName="{{day+'AfternoonTo'}}"
                                                              />
                                                              <cx-form-errors [control]="form.get(day+'AfternoonTo')"></cx-form-errors>
                                                            </td>
                                                          </tr>
                                                        }
                                                      </tbody>
                                                    </table>
                                                  </section>
                                                  @if (storeFeatureGroups$ | async; as storeFeatures) {
                                                    @if (storeFeatures.length > 0) {
                                                      @for (storeFeature of storeFeatures; track storeFeature) {
                                                        <section main class="details">
                                                          <div class="property features">
                                                            <fieldset aria-required="true" class="full-width" formArrayName="features">
                                                              <h5 class="heading">{{storeFeature.name}}</h5>
                                                              <div class="features-container-form">
                                                                @for (feature of storeFeature.features | keyvalue; track feature) {
                                                                  <div class="row">
                                                                    <div class="col col-sm-10 title">
                                                                      {{ feature.value }}
                                                                    </div>
                                                                    <div class="col col-sm-2">
                                                                      <label class="form-check feature-checkbox">
                                                                        <input
                                                                          type="checkbox"
                                                                          class="form-check-input"
                                                                          [checked]="includedFeatures?.includes(feature.key)"
                                                                          [disabled]="form?.status === 'DISABLED'"
                                                                          [id]="feature.key"
                                                                          (change)="checkboxChanged($event,feature.key)"
                                                                          />
                                                                        </label>
                                                                      </div>
                                                                    </div>
                                                                  }
                                                                </div>
                                                              </fieldset>
                                                            </div>
                                                          </section>
                                                        }
                                                      }
                                                    }
                                                  </div>
                                                </form>
                                              }
                                            }

                                          </cx-view>
